export default __webpack_public_path__ + "static/media/1019.06a5176e.png";